import { render, staticRenderFns } from "./PaymentCongratulations.vue?vue&type=template&id=862e667c&scoped=true&"
import script from "./PaymentCongratulations.vue?vue&type=script&lang=js&"
export * from "./PaymentCongratulations.vue?vue&type=script&lang=js&"
import style0 from "./PaymentCongratulations.vue?vue&type=style&index=0&id=862e667c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862e667c",
  null
  
)

export default component.exports